export const fmtTRY = (v) =>
  new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency: "TRY",
    maximumFractionDigits: 2,
  }).format(Number(v || 0));

export const fmtNum = (v) =>
  new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 2 }).format(
    Number(v || 0)
  );

export const fmtDate = (iso) => {
  if (!iso) return "";
  const d = typeof iso === "string" ? new Date(iso) : iso;
  return new Intl.DateTimeFormat("tr-TR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(d);
};

// gg/aa/yyyy - Rapor (PDF/Excel) çıktıları için numeric slash format.
// ISO yyyy-mm-dd geldiğinde timezone kaymasını önlemek için elle parse ediyoruz.
export const fmtDateSlash = (iso) => {
  if (!iso) return "";
  if (typeof iso === "string") {
    const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m) return `${m[3]}/${m[2]}/${m[1]}`;
    const d = new Date(iso);
    if (!isNaN(d)) {
      const dd = String(d.getDate()).padStart(2, "0");
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      return `${dd}/${mm}/${d.getFullYear()}`;
    }
    return iso;
  }
  const dd = String(iso.getDate()).padStart(2, "0");
  const mm = String(iso.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}/${iso.getFullYear()}`;
};

export const fmtMonth = (yyyymm) => {
  const [y, m] = yyyymm.split("-");
  const d = new Date(Number(y), Number(m) - 1, 1);
  return new Intl.DateTimeFormat("tr-TR", { month: "short", year: "2-digit" })
    .format(d)
    .replace(".", "");
};

export const todayISO = () => new Date().toISOString().slice(0, 10);
